export default class ProcessIds {
	_processInstanceId;
	_activityInstanceId;
	_cycle;

	constructor(props = {}) {
		Object.keys(props)
		.forEach((propName) => this[`_${propName}`] = props[propName]);
	}

	equals(otherProcessIds) {
		return otherProcessIds.processInstanceId === this.processInstanceId &&
		otherProcessIds.activityInstanceId === this.activityInstanceId &&
		otherProcessIds.cycle === this.cycle;
	}

	get processInstanceId() {
		return this._processInstanceId;
	}

	set processInstanceId(value) {
		this._processInstanceId = value;
	}

	get activityInstanceId() {
		return this._activityInstanceId;
	}

	set activityInstanceId(value) {
		this._activityInstanceId = value;
	}

	get cycle() {
		return this._cycle;
	}

	set cycle(value) {
		this._cycle = value;
	}
}
